export const environment = {
  production: false,
  propertyManagerPortalBaseUrl: '',
  pspV1BaseUrl: '',
  payLaterUrl: ''
};
